import { PageCardActions } from './Actions';
import { PageCardApiResponse } from './ApiResponse';
import { PageCard } from './Card';
import { PageCardEvents } from './Events';
import { PageCardInformation } from './Information';
import { PageCardsOverview } from './Overview';

export { PageCardsOverview } from './Overview';

export const CARDS = {
  Cards: PageCardsOverview,
  CardSection: PageCard,
  CardEdit: PageCardInformation,
  CardEvents: PageCardEvents,
  CardActions: PageCardActions,
  CardApiResponse: PageCardApiResponse,
} as const;
